export const ROOM_TYPE_LIST = [
  {
    label: "Music Hall",
    value: "1",
  },
  {
    label: "Music Practice Room",
    value: "2",
  },
];

export const PAYMENT_STATUS = [
  {
    label: "Pending",
    value: "1",
  },
  {
    label: "Completed",
    value: "2",
  },
  {
    label: "Failed",
    value: "3",
  },
];

export const ACKNOWLEDGED_STATUS = [
  {
    label: "รอแอดมินรับทราบ",
    value: "1",
  },
  {
    label: "แอดมินรับทราบแล้ว",
    value: "2",
  },
];

export const RENDER_ROOM_TYPE = (type) => {
  switch (type) {
    case "1":
      return {
        labelTh: "Music Hall",
      };
    case "2":
      return {
        labelTh: "Music Practice Room",
      };
    default:
      return {
        labelTh: "",
      };
  }
};

export const RENDER_BOOKING_STATUS = (status) => {
  switch (status) {
    case "1":
      return {
        labelEn: "Draft",
        txtColor: "#000000",
        bgColor: "#D9D9D9",
      };
    case "2":
      return {
        labelEn: "Waiting for Confirm from Admin",
        txtColor: "#FFFFFF",
        bgColor: "#D9C316",
      };
    case "3":
      return {
        labelEn: "Detail Approved, Wait for Slip",
        txtColor: "#000000",
        bgColor: "#FFF500",
      };
    case "4":
      return {
        labelEn: "Waiting for Slip Confirmation from Admin",
        txtColor: "#4B1E78",
        bgColor: "#FFF500",
      };
    case "5":
      return {
        labelEn: "Detail + Slip Approved",
        txtColor: "#FFFFFF",
        bgColor: "#328826",
      };
    case "6":
      return {
        labelEn: "Reject, Need more Info",
        txtColor: "#FFFFFF",
        bgColor: "#FF0000",
      };
    case "7":
      return {
        labelEn: "Cancel (by Customer)",
        txtColor: "#FFFFFF",
        bgColor: "#A9A9A9",
      };
    default:
      return {
        labelEn: "",
        txtColor: "#000000",
        bgColor: "#FFFFFF",
      };
  }
};

export const RENDER_BOOKING_EVENT_STATUS = (status) => {
  switch (status) {
    case "1":
      return {
        labelEn: "Waiting for event",
        txtColor: "#FFFFFF",
        bgColor: "#D9C316",
      };
    case "2":
      return {
        labelEn: "Checking before Close",
        txtColor: "#000000",
        bgColor: "#FFF500",
      };
    case "3":
      return {
        labelEn: "Closed - Success",
        txtColor: "#FFFFFF",
        bgColor: "#328826",
      };
    case "4":
      return {
        labelEn: "Closed - No Show",
        txtColor: "#FFFFFF",
        bgColor: "#FF0000",
      };
    case "5":
      return {
        labelEn: "N/A",
        txtColor: "#FFFFFF",
        bgColor: "#A9A9A9",
      };
    default:
      return {
        labelEn: "",
        txtColor: "#000000",
        bgColor: "#FFFFFF",
      };
  }
};

export const BOOKING_STATUS = [
  {
    label: "Draft",
    value: "1",
  },
  {
    label: "Waiting for Confirm from Admin",
    value: "2",
  },
  {
    label: "Detail Approved, Wait for Slip",
    value: "3",
  },
  {
    label: "Waiting for Slip Confirmation from Admin",
    value: "4",
  },
  {
    label: "Detail + Slip Approved",
    value: "5",
  },
  {
    label: "Reject, Need more Info",
    value: "6",
  },
  {
    label: "Cancel (by Customer)",
    value: "7",
  },
];

export const BOOKING_EVENT_STATUS = [
  {
    label: "Waiting for event",
    value: "1",
  },
  {
    label: "Checking before Close",
    value: "2",
  },
  {
    label: "Closed - Success",
    value: "3",
  },
  {
    label: "Closed - No Show",
    value: "4",
  },
  {
    label: "N/A",
    value: "5",
  },
];

export const RENDER_PAYMENT_STATUS = (status) => {
  switch (status) {
    case "1":
      return {
        labelTh: "รอชำระเงิน",
        txtColor: "#000000",
        bgColor: "#D9D9D9",
      };
    case "2":
      return {
        labelTh: "โอนสำเร็จ",
        txtColor: "#5CB719",
        bgColor: "#328826",
      };
    case "3":
      return {
        labelTh: "โอนไม่สำเร็จ",
        txtColor: "#FF0000",
        bgColor: "#FF0000",
      };
    default:
      return {
        labelEn: "",
        txtColor: "#000000",
        bgColor: "#FFFFFF",
      };
  }
};

export const RENDER_ACKNOWLEDGED_STATUS = (status) => {
  switch (status) {
    case "1":
      return {
        labelTh: "รอแอดมินรับทราบ",
        txtColor: "#222020",
        bgColor: "#EAAE28",
      };
    case "2":
      return {
        labelTh: "แอดมินรับทราบแล้ว",
        txtColor: "#222020",
        bgColor: "#94E559",
      };
    default:
      return {
        labelEn: "",
        txtColor: "#222020",
        bgColor: "#FFFFFF",
      };
  }
};

export const RENDER_ACKNOWLEDGED_STATUS_ALL = (e) => {
  if (e) {
    return {
      labelTh: "แอดมินรับทราบแล้ว",
      txtColor: "#222020",
      bgColor: "#94E559",
    };
  } else {
    return {
      labelTh: "รอแอดมินรับทราบ",
      txtColor: "#222020",
      bgColor: "#EAAE28",
    };
  }
};

export const RENDER_EVENT_TYPE = (type) => {
  switch (type) {
    case "1":
      return {
        labelEn: "Concert",
      };
    case "2":
      return {
        labelEn: "Competition",
      };
    case "3":
      return {
        labelEn: "Recording",
      };
    case "4":
      return {
        labelEn: "Racital",
      };
    case "5":
      return {
        labelEn: "Rehearsal",
      };
    case "6":
      return {
        labelEn: "Master Class / Workshop",
      };
    case "7":
      return {
        labelEn: "Exhibitiont",
      };
    case "8":
      return {
        labelEn: "Seminar / Forum",
      };

    default:
      return {
        labelEn: "",
      };
  }
};

export const BOOKING_SOURCE = [
  {
    label: "Customer",
    value: "1",
  },
  {
    label: "Internal",
    value: "2",
  },
  {
    label: "Music Academy",
    value: "3",
  },
];

export const RENDER_BOOKING_SOURCE = (source) => {
  switch (source) {
    case "1":
      return {
        labelEn: "Customer",
        txtColor: "#0B50EB",
      };
    case "2":
      return {
        labelEn: "Internal",
        txtColor: "#4B1E78",
      };
    case "3":
      return {
        labelEn: "Music Academy",
        txtColor: "#FF0000",
      };
    default:
      return {
        labelEn: "",
        txtColor: "#000000",
      };
  }
};
